import { interpolate } from '../../global';
import { ILanguageResources, ITranslationModule } from '../../interfaces';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.webmodule-common.other.ToastAway.';
  public static readonly successTitle = `${Id.prefix}successTitle`;
  public static readonly informationTitle = `${Id.prefix}informationTitle`;
  public static readonly warningTitle = `${Id.prefix}warningTitle`;
  public static readonly errorTitle = `${Id.prefix}errorTitle`;
  public static readonly unauthenticatedTitle = `${Id.prefix}unauthenticatedTitle`;
  public static readonly unauthenticatedMessage = `${Id.prefix}unauthenticatedMessage`;
  public static readonly unauthorizedTitle = `${Id.prefix}unauthorizedTitle`;
  public static readonly unauthorizedMessage = `${Id.prefix}unauthorizedMessage`;
  public static readonly unknownErrorMessage = `${Id.prefix}unknownErrorMessage`;
  public static readonly closeButton = `${Id.prefix}closeButton`;
}

export class LangToastAway {
  private constructor() {}
  public static successTitle(): string {
    return interpolate(Id.successTitle);
  }
  public static informationTitle(): string {
    return interpolate(Id.informationTitle);
  }
  public static warningTitle(): string {
    return interpolate(Id.warningTitle);
  }
  public static errorTitle(): string {
    return interpolate(Id.errorTitle);
  }
  public static unauthenticatedTitle(): string {
    return interpolate(Id.unauthenticatedTitle);
  }
  public static unauthenticatedMessage(): string {
    return interpolate(Id.unauthenticatedMessage);
  }
  public static unauthorizedTitle(): string {
    return interpolate(Id.unauthorizedTitle);
  }
  public static unauthorizedMessage(): string {
    return interpolate(Id.unauthorizedMessage);
  }
  public static unknownErrorMessage(): string {
    return interpolate(Id.unknownErrorMessage);
  }
  public static closeButton(): string {
    return interpolate(Id.closeButton);
  }
}

export class ToastAwayModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.successTitle, 'Success', 'Toast title for success');
    register.add(Id.informationTitle, 'Information', 'Toast title for information');
    register.add(Id.warningTitle, 'Warning', 'Toast title for warning');
    register.add(Id.errorTitle, 'Error', 'Toast title for error');
    register.add(Id.unauthenticatedTitle, 'UnAuthenticated', 'Toast title for unauthenticated error');
    register.add(
      Id.unauthenticatedMessage,
      'Please contact admin if you are having trouble',
      'Toast message for unauthenticated error'
    );
    register.add(Id.unauthorizedTitle, 'UnAuthorized', 'Toast title for unauthorized error');
    register.add(
      Id.unauthorizedMessage,
      'You do not have the permission for this process',
      'Toast message for unauthorized error'
    );
    register.add(Id.unknownErrorMessage, 'Unknown Error', 'Toast message for unknown error');
    register.add(Id.closeButton, 'Close', 'Toast close button label');
  }
}
